import merge from 'lodash.merge';

export const mergeObjects = (object, sources) => merge(object, sources);
